import { render, staticRenderFns } from "./InfoComponent.vue?vue&type=template&id=c8c51b9c&scoped=true"
import script from "./InfoComponent.vue?vue&type=script&lang=js"
export * from "./InfoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c51b9c",
  null
  
)

export default component.exports